import {React, useEffect, useState} from 'react'

export default function Score({id, changeScores,defaultScore}) {
  const [value, setValue] = useState(defaultScore||0);

  function changeHangler(e) {
    setValue(e.target.value < 0 ? -e.target.value : e.target.value);
    if(Number.isInteger(Number(e.target.value))){
      setValue(e.target.value)
    }
    else{
      setValue(Math.floor(Number(e.target.value)));
    }
  }

  useEffect(()=>{
    changeScores(id,value)
  },[value])

  return(
      <input type='number' min={0} step={1}onChange={(e)=>changeHangler(e)} value={value} className="test-creator-test-question-input"/> 
  )
}